import './styles.css';

function getTextNodesIn(container) {
  const textNodes = [];
  const walker = document.createTreeWalker(
    container,
    NodeFilter.SHOW_TEXT,
    null,
    false,
  );

  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  return textNodes;
}

function getConcatenatedTextAndOffsets(textNodes) {
  const textContents = [];
  const offsets = [];
  let lengthSoFar = 0;

  textNodes.forEach((node) => {
    const { textContent } = node;
    textContents.push(textContent);

    const start = lengthSoFar;
    lengthSoFar += textContent.length;
    const end = lengthSoFar;

    offsets.push({ node, start, end });
  });

  const concatenatedText = textContents.join('');
  return { concatenatedText, offsets };
}

function findGlobalIndices(concatenatedText, targetText) {
  const startIndex = concatenatedText.indexOf(targetText);
  if (startIndex === -1) {
    return null;
  }
  const endIndex = startIndex + targetText.length;
  return { startIndex, endIndex };
}

function mapIndexToNode(offsets, index) {
  let low = 0;
  let high = offsets.length - 1;

  while (low <= high) {
    const mid = Math.floor((low + high) / 2);
    const { start, end } = offsets[mid];

    if (index < start) {
      high = mid - 1;
    } else if (index >= end) {
      low = mid + 1;
    } else {
      // Index is within this node
      const { node } = offsets[mid];
      const offsetInNode = index - start;
      return { node, offset: offsetInNode };
    }
  }

  return null;
}

function mapIndicesToNodes(offsets, startIndex, endIndex) {
  const startMapping = mapIndexToNode(offsets, startIndex);
  const endMapping = mapIndexToNode(offsets, endIndex - 1);

  if (startMapping && endMapping) {
    return {
      startNode: startMapping.node,
      startOffset: startMapping.offset,
      endNode: endMapping.node,
      endOffset: endMapping.offset + 1,
    };
  }
  return null;
}

function createRange(startNode, startOffset, endNode, endOffset) {
  const range = document.createRange();
  range.setStart(startNode, startOffset);
  range.setEnd(endNode, endOffset);
  return range;
}

export function calculatePositions(range) {
  const rects = range.getClientRects();

  if (rects.length === 0) {
    return null;
  }

  let topPosition = rects[0].top + window.scrollY;
  let bottomPosition = rects[0].bottom + window.scrollY;
  let leftPosition = rects[0].left;

  // eslint-disable-next-line no-restricted-syntax
  for (const rect of rects) {
    const rectTop = rect.top + window.scrollY;
    const rectBottom = rect.bottom + window.scrollY;

    if (rectTop < topPosition) topPosition = rectTop;
    if (rectBottom > bottomPosition) bottomPosition = rectBottom;
    if (rect.left < leftPosition) leftPosition = rect.left;
  }

  return { topPosition, bottomPosition, leftPosition };
}

export function deleteVerticalLine() {
  const verticalLine = document.getElementById('vertical-line');

  if (verticalLine) {
    verticalLine.remove();
  }
}

export function positionVerticalLine(positions, container) {
  if (!positions || !container) {
    return;
  }
  let verticalLine = container.querySelector('#vertical-line');
  if (!verticalLine) {
    verticalLine = document.createElement('div');
    verticalLine.id = 'vertical-line';
    container.appendChild(verticalLine);
  }

  verticalLine.style.position = 'absolute';
  verticalLine.style.left = '-10px'; // Position relative to container
  verticalLine.style.top = `${positions.topPosition - container.getBoundingClientRect().top}px`;
  verticalLine.style.height = `${positions.bottomPosition - positions.topPosition}px`;
  verticalLine.style.width = '4px';
  verticalLine.style.borderRadius = '2px';
  verticalLine.style.backgroundColor = '#192c47';
  verticalLine.style.zIndex = '9999';
}

export function getPositions(marker) {
  const textToFind = marker.text;

  const container = document.getElementById('full-transcript');

  if (container) {
    const allElements = container.querySelectorAll('*');

    const elements = Array.from(allElements).filter((element) => element.innerText.includes(textToFind));
    if (elements.length === 0) {
      return null;
    }
    const element = elements.find((el) => el.classList.contains('piece-highlighted'));
    const index = elements.indexOf(element);
    let parentElement = elements[index - 1];

    if (!parentElement) {
      parentElement = elements[elements.length - 1];
    }

    parentElement.style.position = 'relative';

    const textNodes = getTextNodesIn(parentElement);
    const { concatenatedText, offsets } = getConcatenatedTextAndOffsets(textNodes);
    const indexes = findGlobalIndices(concatenatedText, textToFind);
    const mapping = mapIndicesToNodes(offsets, indexes.startIndex, indexes.endIndex);
    const range = createRange(mapping.startNode, mapping.startOffset, mapping.endNode, mapping.endOffset);
    const positions = calculatePositions(range);

    if (positions && parentElement) {
      return { positions, parentElement };
    }

    return null;
  }
  return null;
}

export function highlightText(marker) {
  const textToFind = marker.text;
  // find the whole page the words that we need to highlight
  const container = document.getElementById('full-transcript');

  if (container) {
    const allElements = container.querySelectorAll('*');

    const elements = Array.from(allElements).filter((element) => element.innerText.includes(textToFind));

    // elements is an array of elements, one of those elements has the class piece-highlighted, get the element that comes right before it
    const element = elements.find((el) => el.classList.contains('piece-highlighted'));
    const index = elements.indexOf(element);
    const previousElement = elements[index - 1];

    const textNodes = getTextNodesIn(previousElement);
    const { concatenatedText, offsets } = getConcatenatedTextAndOffsets(textNodes);
    const indexes = findGlobalIndices(concatenatedText, textToFind);

    const mapping = mapIndicesToNodes(offsets, indexes.startIndex, indexes.endIndex);

    const range = createRange(mapping.startNode, mapping.startOffset, mapping.endNode, mapping.endOffset);
    const positions = calculatePositions(range);

    positionVerticalLine(positions);
  }
}
